import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Grid,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// font-awesome
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import AppSnackbar from "layouts/notifications/Snackbar";
import { getCountries, getStates, getDistricts, getPrograms } from "services/sdbService";
import { addUser } from "services/userService";
import { UI_LOCALE_OPTIONS } from "constants/uiLocales";
import { getUserInfo } from "services/authService";
import { useTranslation } from "hooks/useTranslation";

// Helper validation function (can be moved to utils/validators.js)
function validateForm(form) {
  const errors = {};

  if (!form.first_name) errors.first_name = "First name is required";
  if (!form.last_name) errors.last_name = "Last name is required";

  //  Phone Number Validation
  if (!form.phoneNumber) {
    errors.phoneNumber = "Phone number is required";
  } else if (!/^\d{10}$/.test(form.phoneNumber)) {
    errors.phoneNumber = "Phone must be a 10-digit number";
  }

  //  email_id Validation
  if (!form.email_id) {
    errors.email_id = "email_id is required";
    // } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email_id)) {
  } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email_id)) {
    errors.email_id = "email_id is invalid";
  }

  // if (!form.userName) errors.userName = "User name is required";
  if (!form.password) errors.password = "Password is required";
  if (!form.confirmPassword) errors.confirmPassword = "Confirm Password is required";
  if (form.password && form.confirmPassword && form.password !== form.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  if (!form.country) errors.country = "Country is required";
  if (!form.state) errors.state = "State is required";
  if (!form.district) errors.district = "District is required";
  if (!form.language) errors.language = "Language is required";
  if (!form.program) errors.program = "Program name is required";

  return errors;
}

export default function AddAnnotator({ open, onClose, onSuccess }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    phoneNumber: "",
    email_id: "",
    // userName: "",
    password: "",
    confirmPassword: "",
    country: "Colombia",
    state: "",
    district: "",
    block: "",
    language: "en",
    program: "Readnet Colombia",
  });

  //fetching logged user info
  const user = getUserInfo();

  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [openDropdown, setOpenDropdown] = useState({});
  // Toast-snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    type: "",
    message: "",
  });
  const showSnackbar = (type, message) => {
    setSnackbar({ open: true, type, message });
  };
  const closeSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
      type: "",
      message: "",
    }));
  };

  //  Reset form on modal open
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const states = await getStates(form.country);
        setStates(states);
      } catch (error) {
        console.error("Failed to fetch dropdown data", error);
      }
    };

    if (open) {
      setForm({
        first_name: "",
        last_name: "",
        phoneNumber: "",
        email_id: "",
        password: "",
        confirmPassword: "",
        country: "Colombia",
        state: "",
        district: "",
        block: "",
        language: "en",
        program: "Readnet Colombia",
      });
      setStates([]);
      setDistricts([]);
      fetchDropdownData();
      setErrors({});
    }
  }, [open]);

  /* handlers of form fields */

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleState = (field) => async (e) => {
    const value = e.target.value;
    setForm({ ...form, [field]: value });
    setSelectedState(value);
    const districts = await getDistricts(value);
    setDistricts(districts);
  };

  const handleDistrict = (field) => async (e) => {
    const value = e.target.value;
    setForm({ ...form, [field]: value });
    setSelectedDistrict(value);
  };

  const handleSubmit = async () => {
    const validationErrors = validateForm(form);
    console.log(Object.keys(validationErrors));
    if (Object.keys(validationErrors).length === 0) {
      console.log("Submitting form:", form);
      await saveAnnotator(form);
      onSuccess?.();
    } else {
      setErrors(validationErrors);
    }
  };
  const handleCancel = () => {
    setForm({
      first_name: "",
      last_name: "",
      phoneNumber: "",
      email_id: "",
      // userName: "",
      password: "",
      confirmPassword: "",
      country: "",
      state: "",
      district: "",
      block: "",
      language: "en",
      program: "",
    });
    setErrors({});
    onClose();
  };

  const handleNumericChange = (field) => (e) => {
    const value = e.target.value;
    // Allow only digits (or empty string)
    if (/^\d*$/.test(value)) {
      setForm({ ...form, [field]: value });
    }
  };

  const renderSelectField = (
    label,
    field,
    field_value,
    options,
    handler,
    option_value,
    option_label
  ) => (
    <FormControl fullWidth required error={Boolean(errors[field])}>
      <InputLabel id={`${field}-label`}>{label}</InputLabel>
      <Select
        labelId={`${field}-label`}
        value={field_value}
        label={label}
        onChange={handler ? handler(field) : handleChange(field)}
        sx={{
          height: 50,
          fontSize: "1rem",
          "& svg": {
            top: "calc(50% - 0.5em)",
            right: 10,
            position: "absolute",
            pointerEvents: "none",
            color: "gray",
          },
        }}
        onOpen={() => setOpenDropdown((prev) => ({ ...prev, [field]: true }))}
        onClose={() => setOpenDropdown((prev) => ({ ...prev, [field]: false }))}
        IconComponent={() => (
          <FontAwesomeIcon icon={openDropdown[field] ? faChevronUp : faChevronDown} />
        )}
      >
        {option_value != "" && option_label != ""
          ? options?.map((option) => (
              <MenuItem key={option[option_value]} value={option[option_value]}>
                {option[option_label]}
              </MenuItem>
            ))
          : options?.map((option, index) => (
              <MenuItem key={index} value={option}>
                {option}
              </MenuItem>
            ))}
      </Select>
      {errors[field] && (
        <p style={{ color: "red", fontSize: "0.75rem", marginTop: 4 }}>{errors[field]}</p>
      )}
    </FormControl>
  );

  const renderTextField = (label, field, field_value, type, disabled) => (
    <TextField
      label={label}
      type={type}
      fullWidth
      required={!disabled}
      value={field_value}
      onChange={handleChange(field)}
      error={Boolean(errors[field])}
      helperText={errors[field]}
      variant="outlined"
      sx={{ fontSize: "1rem" }}
      disabled={disabled}
    />
  );

  /* save annotator api call */
  async function saveAnnotator(form) {
    let annotatorObj = {
      role: "Annotator",
      country: form.country,
      state: form.state,
      district: form.district,
      block: form.block,
      program_id: form.program,
      language: form.language,
      first_name: form.first_name,
      last_name: form.last_name,
      email_id: form.email_id,
      password: form.password,
      phone_number: form.phoneNumber,
      created_by: user.id,
    };

    let result = await addUser(annotatorObj);
    if (result.status == "success") {
      showSnackbar("success", result.message);
      onClose();
    } else {
      showSnackbar("error", result.message);
    }
  }

  return (
    <>
      <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
        <MDBox p={3}>
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 0,
              mb: 2,
            }}
          >
            <MDTypography variant="h6">
              {t("superAdmin.modals.addAnnotator", "Add Annotator Details")}
            </MDTypography>
            <IconButton onClick={handleCancel}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.firstName", "First Name"),
                "first_name",
                form.first_name
              )}
            </Grid>
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.lastName", "Last Name"),
                "last_name",
                form.last_name
              )}
            </Grid>
            <Grid item xs={6}>
              {/* {renderTextField("Phone Number", "phoneNumber")} */}
              <TextField
                label={t("admin.annotators.modals.fields.phoneNumber", "Phone Number")}
                fullWidth
                required
                type="text"
                value={form.phoneNumber}
                onChange={handleNumericChange("phoneNumber")}
                error={Boolean(errors.phoneNumber)}
                helperText={errors.phoneNumber}
                variant="outlined"
                inputProps={{ maxLength: 10, inputMode: "numeric", pattern: "[0-9]*" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <span style={{ fontSize: "0.875rem", color: "#666" }}>+57</span>
                    </InputAdornment>
                  ),
                }}
                sx={{ "& input": { fontSize: "0.875rem" } }}
              />
            </Grid>
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.email", "Email"),
                "email_id",
                form.email_id
              )}
            </Grid>
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.country", "Country"),
                "country",
                form.country,
                "",
                true
              )}
            </Grid>
            <Grid item xs={6}>
              {renderSelectField(
                t("admin.annotators.modals.fields.state", "State"),
                "state",
                form.state,
                states,
                handleState,
                "state",
                "state"
              )}
            </Grid>
            <Grid item xs={6}>
              {renderSelectField(
                t("admin.annotators.modals.fields.district", "District"),
                "district",
                form.district,
                districts,
                handleDistrict,
                "district",
                "district"
              )}
            </Grid>
            <Grid item xs={6}>
              {renderSelectField(
                t("superAdmin.modals.portalLanguage", "Portal language"),
                "language",
                form.language,
                UI_LOCALE_OPTIONS,
                null,
                "code",
                "label"
              )}
            </Grid>
            {/* <Grid item xs={6}>
              {renderTextField("User Name", "userName", form.userName)}
            </Grid> */}
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.program", "Program"),
                "program",
                form.program,
                "",
                true
              )}
            </Grid>
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.password", "Password"),
                "password",
                form.password,
                "password"
              )}
            </Grid>
            <Grid item xs={6}>
              {renderTextField(
                t("admin.annotators.modals.fields.confirmPassword", "Confirm Password"),
                "confirmPassword",
                form.confirmPassword,
                "password"
              )}
            </Grid>

            <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2} mt={2}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{
                  backgroundColor: "#28a745", // Bootstrap success green
                  color: "#fff",
                  border: "2px solid #218838",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  padding: "8px 24px",
                  textTransform: "none", // Prevent ALL CAPS
                  fontSize: "1rem",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  "&:hover": {
                    backgroundColor: "#218838", // Darker green on hover
                    borderColor: "#1e7e34",
                  },
                  "&:active": {
                    boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                  },
                }}
              >
                {t("admin.annotators.modals.buttons.save", "Save")}
              </Button>
              <Button onClick={handleCancel} variant="contained" color="success">
                {t("admin.annotators.modals.buttons.cancel", "Cancel")}
              </Button>
            </Grid>
          </Grid>
        </MDBox>
      </Dialog>
      <AppSnackbar
        type={snackbar.type}
        message={snackbar.message}
        open={snackbar.open}
        onClose={closeSnackbar}
      />
    </>
  );
}

AddAnnotator.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};
